module.exports = __webpack_public_path__ + "img/example_fe.8210e637.png";